module.exports = __webpack_public_path__ + "static/media/bus.c59be392.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bus.png
// module id = 461
// module chunks = 0